<template>
	<b-modal ref="profile_modal"
			 size="lg"
			 bodyClass="p-0"
			 v-bind:no-close-on-backdrop=true
			 :hide-header=true
			 v-model="is_show_modal"
			 :dialogClass=dialog_class_draw>

		<template v-slot:modal-header="{ close }">
			<!-- Emulate built in modal header close button action -->
			<b-button size="sm" variant="outline-danger" @click="close_modal">
				Close Modal
			</b-button>
		</template>

		<div id="panel_user_list" class="panel mb-0 border-bottom-0 shadow-none">
			<div class="panel-hdr border-faded border-top-0 border-right-0 border-left-0 shadow-0">
				<h2 >
					<span class="fw-300">

					</span>
				</h2>
				<div class="panel-toolbar pr-3 pb-2 align-self-end">
					<button class="btn btn-panel bg-transparent fs-xl w-auto h-auto rounded-0 waves-effect waves-themed" v-on:click="close_modal">
						<i class="fal fa-times"></i>
					</button>
				</div>
			</div>

			<div class="panel-container show">
				<b-overlay :show="is_load" rounded="sm">
					<div class="imc_memorandum_inside ">
						<div class="sluzebka_inside ">
							<div class="body_sluz ">
								<div class="container-fluid">
									<b-row class="doc_title mt-3 mb-3" :key="field.id" v-for="field in this.edit_fields">
										<b-col sm="4">
											<label :for="field.field_type + field.id">{{field.field_name}} </label>
										</b-col>
										<b-col sm="8">
											<b-form-input
												type="text"
												class="fs-xl"
												v-if="field.field_type == 'input'"
												:state="is_valid_field(field)"
												v-model="field.field_val"
												:id="field.field_type + field.id"
												size="sm" >
											</b-form-input>

											<b-form-radio-group
												id="btn-radios-1"
												v-if="field.field_type == 'enum_vid_remont'"
												v-model="field.field_val"
												button-variant="outline-primary"
												:options="remont_options"
												name="radios-btn-default"
												buttons
											></b-form-radio-group>

											<date-picker
												v-if="field.field_type == 'date'"
												value-type="format"
												v-model="field.field_val"
												:lang="d_lang"
												:first-day-of-week="1"
											>
											</date-picker>

											<v-select
													  v-model="field.field_json"
													  v-if="field.field_type == 'api_place'"
													  class="imc_reasons"
													  label="name"
													  :options="draw_places_fields"
													  :filterable="false"
											>
												<template slot="no-options">
													Оберіть склад
												</template>
												<template slot="option" slot-scope="option">
													<div class="d-center">
														{{ option.name }}
														<small >{{option.edrpou}}</small>
													</div>
												</template>
											</v-select>
										</b-col>
									</b-row>
								</div>
							</div>
						</div>
					</div>
				</b-overlay>
			</div>
		</div>

		<template v-slot:modal-footer="{close}">
			<div class="modal-footer">
				<button type="button" v-on:click="close_modal" class="btn btn-secondary waves-effect waves-themed">
					Закрити
				</button>

				<button type="button" v-on:click="save_head" class="btn btn-primary waves-effect waves-themed">
					Зберегти
				</button>
			</div>
		</template>
	</b-modal>
</template>

<script>

import vSelect from 'vue-select';

export default {
	name: "parts_edit_head",
	components : {
		vSelect
	},

	created() {
		EventBus.$on('edit_parts_head',this.check_rights);
		EventBus.$on('edit_partsreserv_head',this.check_rights_reserv);
	},

	props: {
		doc_id: {
			type: String | Number,
			required: true
		},
	},

	data() {
		return {
			is_load: false,
			is_show_modal: false,
			plugin_type : "",
			head_fields : [],
			places : [],
			cur_org_id : 0,
		}
	},
	methods : {
		close_modal() {
			this.is_show_modal = false;
            this.head_fields = [];
            this.plugin_type = '';
            
            
		},
		async save_head() {
			IMC_CORE.showloading();
			await api.patch('/memorandums/' +this.doc_id + '/parts/head', {
					'head_fields' : this.head_fields
				}
			).then(({data}) => {
				if (data.status === "operation_success") {
					IMC_CORE.hideloading();
                    EventBus.$emit("reload_mem", {"mem_id": this.doc_id});
				}
			}).catch(err => {
				IMC_CORE.hideloading();
				EventBus.$emit('show_toast', {err: err.message, type: "danger", title: err.name})
			});
		},

		is_valid_field(field) {
			try {
				if (field.type == 'input') {
					return field.insert_val.toString().length > 1;
				}
			} catch (e) {

			}
			return true;
		},
		async check_rights_reserv(field_type) {
			await this.check_rights(field_type,'parts_reserv')
		},

		async check_rights(field_type,plugin_type = 'reserv') {
			this.plugin_type = plugin_type;
			this.head_fields = [];

			IMC_CORE.showloading();
   
			await api.get('/memorandums/' +this.doc_id + '/rights').then(({data}) => {
				if (data.status === "operation_success") {
					let res = data.data;
					IMC_CORE.hideloading();

					if (res.hasOwnProperty("rights")) {
						let rights = res.rights;
						if (rights === 'active' || rights === 'draft_init' || rights === 'active vip_user' || rights === 'init_user_restart') {
							this.show_modal();
							this.load_memorandum();
						}
					} else {
						EventBus.$emit('show_toast', {
							err: 'Не можливо редагувати!',
							type: "danger",
							title: 'Редагування заблоковано'
						})
					}
				}
			}).catch(err => {
				IMC_CORE.hideloading();
				EventBus.$emit('show_toast', {err: err.message, type: "danger", title: err.name})
			});
		},
		async load_places()
		{
			this.places = [];
			api.get('/parts/places').then(({data}) => {
				if(data.status === 'operation_success') {
					this.places = data.data;
				}
			}).catch(({response}) => {
				EventBus.$emit('show_toast', {err: response.data.message, type: "danger", title: response.data.status,	position : "b-toaster-top-left"})
			});
		},

		async load_memorandum() {
            await api.get('/memorandums/' +this.doc_id).then(({data}) => {
				if (data.status === "operation_success") {
					let memorandum = data.data;
     
					this.cur_org_id = parseInt(memorandum.tov_id);
					let fields_parts = memorandum.addon_data;
					if(fields_parts.hasOwnProperty('head')) {
						fields_parts.head.map(part => {
							this.head_fields.push(part);
						});
					}
     
					if(this.plugin_type === 'parts_reserv') {
						this.load_places();
					}
				}
			}).catch(err => {
				IMC_CORE.hideloading();
				EventBus.$emit('show_toast', {err: err.message, type: "danger", title: err.name})
			});
		},

		show_modal () {
			this.is_show_modal = true;
		},


	},

	computed: {

		d_lang() {
			return this.get_datepickLang();
		},
		edit_fields() {
			if(this.plugin_type == 'reserv') {
				return this.head_fields.filter(item => {
					return item.field_type == 'date'
						|| item.field_type == 'enum_vid_remont'
						|| item.field_type == 'input';
				});
			}

			if(this.plugin_type == 'parts_reserv') {
				return this.head_fields.filter(item => {
					return item.field_type == 'date'
						|| item.field_type == 'api_place';
				});
			}

			return [];
		},
		remont_options() {
			return [{"text":"Плановий","value":"Плановий"},{"text":"Аварійний","value":"Аварійний"}];
		},

		draw_places_fields() {
			return this.places.filter(item => {
				return parseInt(item.tov_id) == parseInt(this.cur_org_id);
			});
		},

		/*place_field : {
			get() {
				return this.place_field_in_fields.field_val;
			},
			set(val) {
				this.place_field_in_fields.field_val = val;
			}
		},*/


		dialog_class_draw () {
			if(this.modal_position === "left") {
				return "modal-dialog-center modal-lg";
			}

			return "modal-dialog-center modal-lg";
		},
	}
}
</script>

<style scoped>

</style>
